import { useEffect } from 'react'

export default function usePageTitle(title, suffix = process.env.REACT_APP_PAGE_TITLE) {
  useEffect(() => {
     document.title = [title, suffix].filter(Boolean).join(' | ');
  }, [ title, suffix]);
}
